/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagGroupList } from '../../models/tag-group-list';

export interface GetTagGroupByTagGroupType$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
}

export function getTagGroupByTagGroupType(http: HttpClient, rootUrl: string, params: GetTagGroupByTagGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroupList>> {
  const rb = new RequestBuilder(rootUrl, getTagGroupByTagGroupType.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagGroupList>;
    })
  );
}

getTagGroupByTagGroupType.PATH = '/tag-group-types/{uid}/tag-groups';
